import { render } from "./bracket_measure_units.html?vue&type=template&id=4e197e52&external"
import script from "./bracket_measure_units.vue?vue&type=script&lang=js"
export * from "./bracket_measure_units.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__